import { createFileRoute } from '@tanstack/react-router'
import { LinkedInSalesNavigator } from '@/features/linkedin-sales-navigator'

export const Route = createFileRoute(
  '/_authenticated/linkedin/sales-navigator/'
)({
  component: LinkedInSalesNavigator,
})
